/* eslint-disable */
import React from "react";
import { useConversation } from "@lobees/chat-core";

import ConversationRightAiPanel from "./ConversationRightAiPanel/ConversationRightAiPanel";
import ConversationRightContactPanel from "./ConversationRightContactPanel/ConversationRightContactPanel";
import ConversationRightWelcomePanel from "./ConversationRightWelcomePanel/ConversationRightWelcomePanel";
import ConversationRightGroupPanel from "./ConversationRightGroupPanel/ConversationRightGroupPanel";
import ConversationRightTaskPanel from "./ConversationRightTaskPanel/ConversationRightTaskPanel";

const ConversationRightPanel = ({
  allContacts = [],

  //history modal states
  setShowHistory = () => {},
  chatSearchMessage = "",
  setChatSearchMessage = () => {},

  //reload group details after adding member
  reloadGroupDetails = false,
  setReloadGroupDetails = () => {},

  //reload chat after ask payment close
  reloadChatAfterPayment = false,
  setReloadChatAfterPayment = () => {},
}) => {
  // screen + the active conversation used to arrive as ~15 separate props
  // threaded from ConversationBody; both now live in the shared conversation
  // context, so each per-channel panel below reads its own identity via
  // useConversation() instead of receiving it here.
  const { screen } = useConversation();

  return (
    <div className="chat_rightpnl">
      {screen === "ai" ? (
        <ConversationRightAiPanel />
      ) : screen === "contact" ? (
        <ConversationRightContactPanel
          //history modal states
          setShowHistory={setShowHistory}
          chatSearchMessage={chatSearchMessage}
          setChatSearchMessage={setChatSearchMessage}
          //reload chat after ask payment close
          reloadChatAfterPayment={reloadChatAfterPayment}
          setReloadChatAfterPayment={setReloadChatAfterPayment}
        />
      ) : screen === "group" ? (
        <ConversationRightGroupPanel
          allContacts={allContacts}
          //history modal states
          setShowHistory={setShowHistory}
          chatSearchMessage={chatSearchMessage}
          setChatSearchMessage={setChatSearchMessage}
          //reload group details after adding member
          reloadGroupDetails={reloadGroupDetails}
          setReloadGroupDetails={setReloadGroupDetails}
        />
      ) : screen === "task" ? (
        <ConversationRightTaskPanel
          allContacts={allContacts}
          //history modal states
          setShowHistory={setShowHistory}
          chatSearchMessage={chatSearchMessage}
          setChatSearchMessage={setChatSearchMessage}
        />
      ) : (
        <ConversationRightWelcomePanel />
      )}
    </div>
  );
};

export default ConversationRightPanel;
